export default __webpack_public_path__ + "static/media/sinso-logo.d7941134.png";